import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";

import Flag from "react-flagkit";

// CSS dosyanızı import edin
import "./LanguageSelection.css";

const LanguageSelection: FC = (props: any) => {
  const { i18n, t } = useTranslation();

  const languages = [
    { code: "TR", name: t("Turkish"), i18n: "tr" },
    { code: "US", name: t("English"), i18n: "en" },
  ];

  // Mevcut dili buluyoruz, yoksa varsayılan ilk dil
  const currentLang =
    languages.find((lang) => lang.i18n === i18n.language) || languages[0];

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return (
    <UncontrolledDropdown
      className="my-language-dropdown" // <-- ÖZEL CLASS BURADA
    >
      <DropdownToggle color="link" className="p-0">
        <Flag country={currentLang.code} size={30} />
      </DropdownToggle>

      <DropdownMenu right>
        {languages.map((lang) => (
          <DropdownItem
            key={lang.code}
            onClick={() => changeLanguage(lang.i18n)}
            active={lang.code === currentLang.code}
          >
            <Flag className="me-2" country={lang.code} size={20} />
            {lang.name}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default LanguageSelection;
